<template>
  <div class="img">
    <img src="/static/img/service_intro/replace/replace-banner.png"/>
  </div>
</template>

<script>
  export default{
    name: 'homeReplaceBanner'
  }
</script>

<style scoped>

  div.img {
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    display: flex;
  }

  div.container {
    padding: 0;
    margin: auto;
    width: auto;
  }

  .firstline {
    font-size: 32px;
  }

  span {
    width: auto;
    font-weight: 700;
    font-style: normal;
    font-family: 'Helvetica-Bold', 'Helvetica Bold', 'Helvetica';
    background-color: rgba(215, 215, 215, 1);
    white-space: nowrap;
    color: #333333;
  }

  .secondline {
    margin-top: 20px;
    font-size: 22px;
    text-align: center;
  }

  span {
    margin-left: 20px;
    margin-right: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// HomeReplaceBanner.vue?a7e717e2